import {Record} from 'immutable';
import {schema} from 'normalizr';

const ParticipantParticipantAttributeValue = Record({
    id: null,
    attribute: null,
    group: null,
    value: null,
    name: null,
});

export const ParticipantParticipantAttributeValueSchema = new schema.Entity('participantParticipantAttributeValues');

export default ParticipantParticipantAttributeValue;
